import { useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Route as GoalsManagementRoute } from "routes/_base/_auth/campaigns/goals/list/route"

export const CreateGoalButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const search = GoalsManagementRoute.useSearch()

  async function handleCreateGoal() {
    navigate({
      to: "/campaigns/goals/list/create",
      search,
    })
  }

  return (
    <Button variant="default" className="h-full" onClick={handleCreateGoal}>
      <Plus className="size-4" strokeWidth={2} />
      <span>{t("campaigns.goalsManagement.create")}</span>
    </Button>
  )
}
